import * as React from 'react';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Components
import { InputPhone } from '@shopee-user/input';

// Types
import { InputProps } from '@shopee-user/input';

export default function SignupInputAuthKeyV2(field: InputProps) {
  const I18n = useTranslation();
  return (
    <InputPhone
      {...field}
      placeholder={I18n.t('label_auth_phone_number')}
      showErrorOutline
      showError
      autoFocus
    />
  );
}
